import React from 'react'
import { Container } from 'react-bootstrap'
import { MdThumbUpAlt } from "react-icons/md";

const ThankYou = () => {
    return (
        <>
            <section className="success-page thank-you">
                <Container>
                    <div className="success-page-content">
                        <MdThumbUpAlt />
                        <h1>Post payment successful page</h1>
                        <strong>Thank you for trusting us for your important event</strong>
                        <p className='pt-2'>
                            We shall provision Insurance Policy certificate with in 24 hours.
                            Please don’t hesitate to reach us on phone number for any queries
                        </p>
                    </div>
                </Container>
            </section>
        </>
    )
}

export default ThankYou